module.exports = __webpack_public_path__ + "static/media/advertencia.110d201f.PNG";